import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { apiClient } from '@api/client/apiClient';
import { queryKeys } from '@api/queryKeys';
import type { CatalogProduct } from '../types';
import type { PaginatedResponse } from '@shared/types';

interface UseCatalogParams {
  search?: string;
  type?: string;
  coverage?: string;
  page?: number;
  size?: number;
}

export function useCatalog(params: UseCatalogParams = {}) {
  const { search, type, coverage, page = 0, size = 50 } = params;

  const queryParams: Record<string, string> = {
    page: String(page + 1),
    size: String(size),
    includeGeometry: 'true',
  };
  if (search) queryParams.search = search;
  if (type) queryParams.type = type;
  if (coverage) queryParams.coverage = coverage;

  return useQuery({
    queryKey: queryKeys.catalog({ search, type, coverage, page, size }),
    queryFn: () =>
      apiClient.get<PaginatedResponse<CatalogProduct>>('/catalog/products', queryParams),
    placeholderData: keepPreviousData,
  });
}
